import { useState } from "react";
import InputSwitch from "../../../../CommonComponents/InputControls/InputSwitch";
import styles from "./EditProfileDetails.module.css";
import CustomInputText from "../../../../CommonComponents/InputControls/CustomInputText";
import InputUploader from "../../../../CommonComponents/InputControls/InputUploader";
import { Col, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ENTERPRISE_COMPANY } from "../../../../../urlConfig";

const EditProfileDetails = ({onSave}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState({
    live_brand_enabled: true,
    companyUrl: "companyname",
    pageTitle: "Company Name",
    headerImg: "",
    profileImg: "",
  });

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value });
  };

  const uploadBanner = async (value) => {};
  const handleBack = async (value) => {
    navigate(ENTERPRISE_COMPANY + location?.pathname?.split("/")?.[3]);
  };
  const handleSave = async (value) => {
    onSave(data)
  };

  return (
    <div className={styles.content_wrap}>
      <div className={styles.title}>Brand Page</div>
      <div className={styles.data_wrap}>
        <div className={styles.checkbox_wrap}>
          <InputSwitch
            title={"Enable live brand page"}
            checked={data.live_brand_enabled}
            onChange={(value) => handleChange("live_brand_enabled", value)}
          />
        </div>
        <CustomInputText
          className={styles.input_wrap}
          lable={"Company URL"}
          value={data.companyUrl}
          onChange={(value) => handleChange("companyUrl", value)}
          prefix={"https://IndexScore.com/company/"}
        />
        <CustomInputText
          className={styles.input_wrap}
          lable={"Page Title"}
          value={data.pageTitle}
          onChange={(value) => handleChange("pageTitle", value)}
        />
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} id="graph_col">
            <InputUploader
              cropped={true}
              className={styles.uploader_wrap}
              lable={"Header image"}
              value={data.headerImg}
              onChange={(value) => handleChange("headerImg", value)}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <InputUploader
              lable={"Profile image"}
              maxWidth={"87px"}
              className={styles.uploader_wrap}
              value={data.profileImg}
              onChange={(value) => handleChange("profileImg", value)}
            />
          </Col>
        </Row>

        <div className={styles.btn_group}>
          <button onClick={handleSave}>Save</button>
          <button onClick={handleBack}>Back</button>
        </div>
      </div>
    </div>
  );
};

export default EditProfileDetails;
